import * as React from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';

interface IProps {
    title: string;
    buttonText: string;
    popUpText: string | JSX.Element;
}

const PopUpButton = (props: IProps) => {
    const popoverClickRootClose = (
        <Popover
            id="popover-trigger-click-root-close"
            className="popup-button-extra-wide-popup"
            title={props.title}
        >
            <p>{props.popUpText}</p>
        </Popover>
    );

    return (
        <OverlayTrigger trigger="click" rootClose placement="right" overlay={popoverClickRootClose}>
            <Button>
                <i className="material-icons md-18">info_outline</i>
                {props.buttonText}{' '}
            </Button>
        </OverlayTrigger>
    );
};

export default PopUpButton;
